// 첫 결제 특가 상품 규칙 (상점·결제 설계 결정 5, 10/28 AC0-258). 첫 결제 특가 = 일반 상품과 짝을 이루는 별도 상품 `<일반 ID>.first`(android·ios·web 공통).
// 판정은 ID 접미사로만 한다(컬럼·플래그 없음). 서버 상점 목록과 어드민 미리보기가 같은 함수를 쓴다.

const SUFFIX = '.first';

/** 첫 결제 특가 상품인가 — ID 가 `.first` 로 끝난다 */
export const isFirstPurchaseProductId = (productId: string): boolean => productId.endsWith(SUFFIX) && productId.length > SUFFIX.length;

/** `.first` 상품의 짝 일반 상품 ID. 일반 상품이면 그대로 */
export const regularProductIdOf = (productId: string): string => (isFirstPurchaseProductId(productId) ? productId.slice(0, -SUFFIX.length) : productId);

/**
 * 상점 표시 목록. 결제 이력 0건(eligible)이면 짝 `.first` 가 있는 일반 상품을 `.first` 로 바꾸고 regular 에 일반 상품을 둔다.
 * 짝이 없는 일반 상품은 그대로, 짝 일반 상품이 목록에 없는 `.first` 는 내보내지 않는다. 결제 이력이 있으면 일반 상품만.
 * 입력은 이미 노출 조건(판매 중·브릭>0·스토어 활성·국가 가격)을 통과한 상품. 순서는 보이는 상품 자신의 sort(`.first` 는 따로 정한다), 같으면 productId.
 */
export const firstPurchaseView = <T extends { productId: string; sort: number }>(items: readonly T[], eligible: boolean): Array<{ item: T; regular: T | null }> => {
  const firsts = new Map(items.filter((i) => isFirstPurchaseProductId(i.productId)).map((i) => [regularProductIdOf(i.productId), i]));
  return items
    .filter((i) => !isFirstPurchaseProductId(i.productId))
    .map((r) => {
      const f = eligible ? firsts.get(r.productId) : undefined;
      return f ? { item: f, regular: r } : { item: r, regular: null };
    })
    .sort((a, b) => a.item.sort - b.item.sort || (a.item.productId < b.item.productId ? -1 : a.item.productId > b.item.productId ? 1 : 0));
};

/** 할인율(%) = 1 − 특가/정가, 반올림. 통화가 다르거나 정가가 0 이하면 null */
export const discountPercent = (price: { currency: string; amountMicros: number }, regular: { currency: string; amountMicros: number }): number | null =>
  price.currency !== regular.currency || regular.amountMicros <= 0 ? null : Math.round((1 - price.amountMicros / regular.amountMicros) * 100);
